"use client";

import { ArrowRight } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SubProductsGrid() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const tickerItems = ["ACERO ESTRUCTURAL", "VIGAS IPR", "CANALES", "ÁNGULOS", "PLACA", "TUBERÍA HSS", "POLINERÍA", "LÁMINA", "VARILLA", "ALAMBRÓN"];
  const dishes = [{
    name: "Viga IPR Estructural",
    ingredients: "Acero de alta resistencia para claros amplios y soporte de carga pesada.",
    price: "Cotizar",
    tilt: "-rotate-1",
    fresh: true,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/viga_ipr_acero.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/viga_ipr_acero.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/viga_ipr_acero.png-wvc-sizes",
    blob: "8% 8% 8% 8% / 8% 8% 8% 8%"
  }, {
    name: "Placa de Acero A-36",
    ingredients: "Ideal para construcción de naves industriales y componentes de maquinaria.",
    price: "Cotizar",
    tilt: "rotate-1",
    fresh: false,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/placa_acero_a36.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/placa_acero_a36.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/placa_acero_a36.png-wvc-sizes",
    blob: "8% 8% 8% 8% / 8% 8% 8% 8%"
  }, {
    name: "Perfil Tubular HSS",
    ingredients: "Secciones estructurales huecas con excelente relación peso-resistencia.",
    price: "Cotizar",
    tilt: "-rotate-1",
    fresh: false,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/perfil_hss_estructural.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/perfil_hss_estructural.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/perfil_hss_estructural.png-wvc-sizes",
    blob: "8% 8% 8% 8% / 8% 8% 8% 8%"
  }, {
    name: "Canal CPS (UPE)",
    ingredients: "Perfiles en forma de U para marcos, soportes y refuerzos estructurales.",
    price: "Cotizar",
    tilt: "rotate-1",
    fresh: true,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/canal_cps_acero.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/canal_cps_acero.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/canal_cps_acero.png-wvc-sizes",
    blob: "8% 8% 8% 8% / 8% 8% 8% 8%"
  }, {
    name: "Ángulo Estructural",
    ingredients: "Versatilidad total para torres de transmisión y estructuras metálicas.",
    price: "Cotizar",
    tilt: "-rotate-1",
    fresh: false,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/angulo_acero_estructural.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/angulo_acero_estructural.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/angulo_acero_estructural.png-wvc-sizes",
    blob: "8% 8% 8% 8% / 8% 8% 8% 8%"
  }, {
    name: "Lámina Galvanizada",
    ingredients: "Recubrimiento de zinc para máxima protección contra la corrosión.",
    price: "Cotizar",
    tilt: "rotate-1",
    fresh: false,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/lamina_galvanizada_r101.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/lamina_galvanizada_r101.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/lamina_galvanizada_r101.png-wvc-sizes",
    blob: "8% 8% 8% 8% / 8% 8% 8% 8%"
  }];
  return <section data-section-id="1194" id="sub-products-grid" className="bg-background text-foreground relative overflow-hidden py-24 md:py-32">
      {}
      <div className="absolute inset-x-0 top-0 z-10 pointer-events-none -translate-y-px">
        <svg viewBox="0 0 1440 64" preserveAspectRatio="none" className="block w-full h-8 md:h-16" aria-hidden="true">
          <path d="M0,32 C180,4 360,60 540,32 C720,4 900,60 1080,32 C1260,4 1440,60 1440,32 L1440,0 L0,0 Z" fill="currentColor" className="text-primary-100" />
        </svg>
      </div>

      {}
      <div className="absolute inset-x-0 top-8 md:top-16 z-0 overflow-hidden border-y border-primary/10 bg-primary-100/20">
        <div className="flex whitespace-nowrap py-2 md:py-3 animate-[ticker_60s_linear_infinite] hover:[animation-play-state:paused]">
          {[...Array(3)].map((_, dup) => <div key={dup} data-index={dup} className="flex shrink-0 items-center">
              {tickerItems.map((item, i) => <div data-index={i} key={`${dup}-${i}`} className="flex items-center font-mono text-xs md:text-sm uppercase tracking-[0.16em] text-primary/60 px-4 md:px-6">
                  <span>{item}</span>
                  <span className="ml-4 md:ml-6 inline-flex items-center" aria-hidden="true">
                    <span className="relative inline-block w-1.5 h-1.5 rounded-md bg-accent">
                      <span className="absolute -top-1 left-1.5 block w-1 h-1.5 rounded-md bg-accent/80" style={{
                  transform: "rotate(35deg)"
                }} />
                    </span>
                  </span>
                </div>)}
            </div>)}
        </div>
      </div>

      {}
      <div aria-hidden="true" className="pointer-events-none absolute -right-24 top-1/3 w-96 h-96 bg-primary/5 hidden md:block" style={{
      borderRadius: "30% 70% 70% 30% / 30% 30% 70% 70%"
    }} />
      <div aria-hidden="true" className="pointer-events-none absolute -left-32 bottom-10 w-80 h-80 bg-secondary/5 hidden md:block" style={{
      borderRadius: "70% 30% 30% 70% / 70% 70% 30% 30%"
    }} />

      <div className="relative z-20 mx-auto w-full max-w-[1320px] px-6 md:px-8 pt-16 md:pt-24">
        {}
        <div ref={headerRef} className={`grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10 items-end mb-14 md:mb-20 transition-all duration-700 ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="md:col-span-8">
            <div className="flex items-center gap-3 mb-6">
              <span className="font-mono text-xs md:text-sm uppercase tracking-[0.16em] text-accent">
                ◐ 02 — Catálogo de Soluciones
              </span>
            </div>
            <h2 className="font-default text-foreground" style={{
            fontSize: "clamp(2.25rem, 5vw, 4.5rem)",
            fontWeight: 700,
            letterSpacing: "-0.02em",
            lineHeight: 1
          }}>
              Acero de{" "}
              <span className="relative inline-block">
                <span className="relative z-10">calidad</span>
                <svg viewBox="0 0 220 60" className="absolute -inset-x-2 -inset-y-1 w-[calc(100%+1rem)] h-[calc(100%+0.5rem)] z-0 pointer-events-none" aria-hidden="true" preserveAspectRatio="none">
                  <path d="M8,42 C50,28 110,50 165,34 C190,28 205,38 212,44" stroke="var(--accent)" strokeWidth="14" strokeLinecap="round" fill="none" opacity="0.2" style={{
                  strokeDasharray: 500,
                  strokeDashoffset: headerVisible ? 0 : 500,
                  transition: "stroke-dashoffset 900ms ease-out 200ms"
                }} />
                </svg>
              </span>{" "}
              industrial
            </h2>
          </div>
          <div className="md:col-span-4 flex flex-col gap-4">
            <p className="text-muted-foreground font-default" style={{
            fontSize: "clamp(1.0625rem, 1.2vw, 1.25rem)",
            lineHeight: 1.55
          }}>
              Disponibilidad inmediata en las principales medidas estructurales para sus proyectos de infraestructura.
            </p>
            <Link to="/CatalogPage" className="group inline-flex items-center gap-2 text-primary font-default font-bold w-fit">
              <span className="relative">
                Ver catálogo completo
                <span className="absolute left-0 -bottom-1 h-0.5 w-full bg-accent transition-all duration-300 group-hover:h-1.5" />
              </span>
              <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-6">
          {dishes.map((dish, i) => <Card data-index={i} key={dish.name} className="group relative bg-card text-card-foreground border border-border transition-all duration-300 ease-out hover:-translate-y-1 hover:shadow-lg pt-0 gap-0" style={{
          borderRadius: "12px",
          borderWidth: "1px"
        }}>
              {}
              <div className="relative p-5 pb-3">
                <div className="relative overflow-hidden aspect-[4/3] bg-muted" style={{
              borderRadius: "8px"
            }}>
                  <img src={dish.image} data-wvc-srcset={dish.srcset} data-wvc-sizes={dish.sizes} alt={dish.name} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                </div>
                {dish.fresh && <Badge variant="outline" className="absolute top-7 left-7 bg-primary text-primary-foreground font-mono uppercase tracking-[0.12em] text-[0.7rem] px-3 py-1 border-none shadow-md" style={{
              borderRadius: "4px"
            }}>
                    Stock Disponible
                  </Badge>}
              </div>

              {}
              <div className="px-6 pb-6 flex flex-col gap-3">
                <h3 className="font-default text-foreground" style={{
              fontSize: "clamp(1.25rem, 2vw, 1.75rem)",
              fontWeight: 700,
              letterSpacing: "-0.01em",
              lineHeight: 1.1
            }}>
                  {dish.name}
                </h3>
                <p className="text-muted-foreground font-default" style={{
              fontSize: "0.95rem",
              lineHeight: 1.55
            }}>
                  {dish.ingredients}
                </p>

                <div className="flex items-center justify-between pt-3 mt-2 border-t border-border">
                  <span className="font-mono text-[0.7rem] uppercase tracking-[0.16em] text-primary font-semibold inline-flex items-center gap-2">
                    <span className="relative inline-block w-1.5 h-1.5 rounded-md bg-secondary" />
                    Grado A-36 / A-572
                  </span>
                  <span className={`inline-flex items-center gap-1 bg-primary text-primary-foreground px-3 py-1.5 font-default font-bold transition-transform duration-300 ${dish.tilt} group-hover:rotate-0 shadow-sm`} style={{
                borderRadius: "6px"
              }}>
                    <span className="font-serif text-sm leading-none">{dish.price}</span>
                  </span>
                </div>
              </div>
            </Card>)}
        </div>

        {}
        <div className="mt-14 md:mt-20 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div className="flex items-center gap-3">
            <span className="relative inline-block w-2 h-2 rounded-md bg-accent">
              <span className="absolute -top-1.5 left-2 block w-1 h-2 rounded-md bg-accent/80" style={{
              transform: "rotate(35deg)"
            }} />
            </span>
            <span className="font-mono text-xs uppercase tracking-[0.16em] text-muted-foreground">
              Precios actualizados según mercado LME
            </span>
          </div>
          <Button asChild className="bg-primary text-primary-foreground hover:bg-primary-600 px-8 py-6 font-default font-bold shadow-md hover:translate-x-0.5 transition-all" style={{
          borderRadius: "8px"
        }}>
            <Link to="/CatalogPage">Solicitar Cotización</Link>
          </Button>
        </div>
      </div>

      <style>{`
        @keyframes ticker {
          0% { transform: translateX(0); }
          100% { transform: translateX(-33.333%); }
        }
      `}</style>
    </section>;
}